<template>
  <SendMessageInput
    v-model="localMessage"
    :showCloseButton="false"
    :title="title"
    :tips="recruitSitterTips"
    :labelName="inputLabel"
    :loading="messageSendLoading"
    @submit="$emit('submit', localMessage)"
  >
    <Button
      v-if="noJobsExist"
      value="Add A Job"
      variant="outlined"
      size="medium"
      class="w-full mt-24"
      :href="`/job-post?jobPostReturnPath=${jobPostReturnPath}`"
    />
    <Dropdown
      v-else
      id="job-dropdown"
      :value="selectedJob"
      class="mt-16"
      labelName="Job"
      name="job"
      :options="jobOptions"
      @input="(val) => $emit('update:selectedJob', val)"
    />
  </SendMessageInput>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';
import SendMessageInput from '@/components/send_message_input/SendMessageInput.vue';

export default {
  name: 'RecruitNotBasic',
  components: {
    Button,
    Dropdown,
    SendMessageInput,
  },
  props: {
    message: {
      required: true,
      type: String,
    },
    recruitSitterTips: {
      required: true,
      type: Array,
    },
    inputLabel: {
      required: true,
      type: String,
    },
    messageSendLoading: {
      required: true,
      type: Boolean,
    },
    noJobsExist: {
      type: Boolean,
      default: false,
    },
    jobPostReturnPath: {
      type: String,
      default: () => '',
    },
    jobOptions: {
      type: Array,
      default: () => [],
    },
    selectedJob: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Start the chat with your job',
    },
  },
  data() {
    return {
      localMessage: this.message,
    };
  },
  watch: {
    message(newValue) {
      this.localMessage = newValue;
    },
    localMessage(newValue) {
      if (newValue !== this.message) {
        this.$emit('input', newValue);
        this.$emit('update:message', newValue);
      }
    },
  },
};
</script>
